import { keys, toArray } from '@fxts/core';

/* Certification Constant Module */
export const TEMP_EMAIL_CERTIFICATION_TYPE = {
  EMAIL: 'EMAIL',
  RESET_PW: 'RESET_PW',
  SNS_CONNECT_VERIFY_EMAIL: 'SNS_CONNECT_VERIFY_EMAIL',
} as const;

export const MEMBER_EMAIL_CERTIFICATION_TYPE = {
  CHANGE_EMAIL: 'CHANGE_EMAIL',
  VERIFY_EMAIL: 'VERIFY_EMAIL',
  SNS_DISCONNECT: 'SNS_DISCONNECT',
} as const;

export const EMAIL_CERTIFICATION_TYPE = {
  ...TEMP_EMAIL_CERTIFICATION_TYPE,
  ...MEMBER_EMAIL_CERTIFICATION_TYPE,
} as const;

export const EMAIL_CERTIFICATION_TYPE_ARRAY = toArray(keys(EMAIL_CERTIFICATION_TYPE));

export const MOBILE_CERTIFICATION_TYPE = {
  FIND_EMAIL: 'FIND_EMAIL',
} as const;

export const MOBILE_CERTIFICATION_TYPE_ARRAY = toArray(keys(MOBILE_CERTIFICATION_TYPE));

export const CERTIFICATION_TYPE = {
  ...TEMP_EMAIL_CERTIFICATION_TYPE,
  ...MEMBER_EMAIL_CERTIFICATION_TYPE,
  ...MOBILE_CERTIFICATION_TYPE,
} as const;

export interface Duration {
  minutes?: number;
  hours?: number;
}

export const CERTIFICATION_VALID_DURATION = { hours: -1 };

export const MOBILE_CERTIFICATION_EXPIRE_DURATION = { minutes: -5 };

export const EMAIL_CERTIFICATION_EXPIRE_DURATION = { minutes: -8 };

export const EMAIL_CERTIFICATION_SIGNUP_EXPIRE_DURATION = { hours: -1 };
